import React from "react";
import Reveal from "./Reveal";
import { ArrowRight } from "lucide-react";
import { brand } from "../mock";

/**
 * ContactCTA — a compact partnership invitation that sits between the
 * Philosophy section and the Footer. Elegant, calm, premium.
 *
 * Responsive notes:
 *  - 24px side padding on mobile, scaling up on tablet/desktop.
 *  - Headline uses clamp() so it never overflows a 320px viewport and never
 *    gets too large on very wide screens. `text-wrap: balance` keeps the
 *    two-line break natural when it wraps.
 *  - The button is comfortable to tap (≥ 44px tall) and has a visible
 *    keyboard focus ring in brand purple.
 */
const ContactCTA = () => {
  return (
    <section
      id="contact-cta"
      className="relative bg-[#FBF6EC] text-neutral-900 scroll-mt-24 md:scroll-mt-32"
      aria-label="Partnership invitation"
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 py-16 sm:py-20 md:py-28 text-center">
        <Reveal>
          <h2
            className="mx-auto font-['Cormorant_Garamond'] text-neutral-900 leading-[1.08] max-w-[18ch] break-words"
            style={{
              fontWeight: 500,
              letterSpacing: "-0.005em",
              fontSize: "clamp(2rem, 6.4vw, 3.75rem)",
              textWrap: "balance",
            }}
          >
            Let’s build what comes next.
          </h2>
        </Reveal>

        <Reveal delay={120}>
          <p
            className="mx-auto mt-5 sm:mt-6 md:mt-8 max-w-xl font-['Montserrat'] font-normal text-neutral-500 leading-relaxed"
            style={{ fontSize: "clamp(0.95rem, 1.6vw, 1.125rem)" }}
          >
            Connect with Nyle to discuss your product development and apparel
            manufacturing needs.
          </p>
        </Reveal>

        <Reveal delay={240}>
          <div className="mt-8 sm:mt-10 md:mt-12">
            <a
              href={`mailto:${brand.email}`}
              data-testid="contact-cta-button"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#7B3FA7] px-7 md:px-8 py-3.5 md:py-4 min-h-[44px] font-['Montserrat'] font-medium text-white text-sm md:text-base shadow-[0_8px_22px_-10px_rgba(123,63,167,0.5)] hover:bg-[#6A2F94] hover:-translate-y-0.5 hover:shadow-[0_14px_28px_-12px_rgba(123,63,167,0.55)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7B3FA7] focus-visible:ring-offset-2 focus-visible:ring-offset-[#FBF6EC] transition-[transform,background-color,box-shadow] duration-300"
              style={{ letterSpacing: "0.04em" }}
            >
              Start a Conversation
              <ArrowRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactCTA;
